import type { UnifiedMethodConfig, ChainCategory } from '../types';

const api: UnifiedMethodConfig[] = [
  {
    method: 'nervosGetAddress',

    presets: [
      {
        title: 'Get address',
        parameters: [
          {
            name: 'path',
            type: 'string',
            required: true,
            label: 'Derivation Path',
            description: 'BIP32 derivation path',
            value: "m/44'/309'/0'/0/0",
          },
          {
            name: 'showOnOneKey',
            type: 'boolean',
            required: false,
            label: 'Show on Device',
            description: '',
            value: false,
          },
          {
            name: 'network',
            type: 'string',
            required: true,
            label: 'Network',
            description: 'Nervos network name',
            value: 'ckb',
          },
        ],
      },
      {
        title: 'Batch Get Address',
        parameters: [
          {
            name: 'bundle',
            type: 'textarea',
            required: true,
            label: 'Bundle Configuration',
            description: 'JSON array of address configurations',
            value: [
              {
                path: "m/44'/309'/0'/0/0",
                network: 'ckb',
                showOnOneKey: false,
              },
              {
                path: "m/44'/309'/1'/0/0",
                network: 'ckb',
                showOnOneKey: false,
              },
              {
                path: "m/44'/309'/2'/0/0",
                network: 'ckb',
                showOnOneKey: false,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    method: 'nervosSignTransaction',

    presets: [
      {
        title: 'Normal Transaction',
        parameters: [
          {
            name: 'path',
            type: 'string',
            required: true,
            label: 'Derivation Path',
            description: 'BIP32 derivation path',
            value: "m/44'/309'/0'/0/0",
          },
          {
            name: 'network',
            type: 'string',
            required: true,
            label: 'Network',
            description: 'Nervos network name',
            value: 'ckb',
          },
          {
            name: 'rawTx',
            type: 'textarea',
            required: true,
            label: 'Raw Transaction',
            description: 'Hex-encoded raw transaction data',
            value:
              'b00100001c000000200000006e00000072000000ce0000009c010000000000000200000071a7ba8fc96349fea0ed3a5c47992e3b4084b031a42264a018e0072e8172e46c0000000001c7813f6a415144643970c2e88e0bb6ca6a8edc5dd7c1022746f628284a9936d50000000000000000000200000000000000000000003ccb539e56ce1acaeb53db6a6ce939132c5f462e7eb686556f3ba308b4c402080100000000000000000000004f4803ed365e368fb6ac0048961883edf1a98daf20a3d73a54d26e4aa601d7d300000000ce0000000c0000006d000000610000001000000018000000610000000002648901000000490000001000000030000000310000009bd7e06f3ecf4be0f2fcd2188b23f1b9fcc88e5d4b65a8637b17723bbda3cce801140000006655cba91b01e4f8e3ecb40d1fb6241a9033115a610000001000000018000000610000009651104802000000490000001000000030000000310000009bd7e06f3ecf4be0f2fcd2188b23f1b9fcc88e5d4b65a8637b17723bbda3cce80114000000fb36a5944e2626089db2f37e9a5cb4a6eff55c82140000000c000000100000000000000000000000',
          },
          {
            name: 'witnessHex',
            type: 'textarea',
            required: true,
            label: 'Witness Hex',
            description: 'Hex-encoded witness data',
            value:
              '55000000100000005500000055000000410000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000',
          },
        ],
      },
      {
        title: 'Mock sUDT Transaction',
        parameters: [
          {
            name: 'path',
            type: 'string',
            required: true,
            label: 'Derivation Path',
            description: 'BIP32 derivation path',
            value: "m/44'/309'/0'/0/0",
          },
          {
            name: 'network',
            type: 'string',
            required: true,
            label: 'Network',
            description: 'Nervos network name',
            value: 'ckb',
          },
          {
            name: 'rawTx',
            type: 'textarea',
            required: true,
            label: 'Raw Transaction',
            description: 'Hex-encoded raw transaction data',
            value:
              '840100001c000000200000006e00000072000000a2000000700100000000000002000000f8de3bb47d055cdf460d93a2a6e1b05f7432f9777c8c474abf4eec1d4aee5d370000000001e12877ebd2c3c364dc46c5c992bcfaf4fee33fa13eebdf82c591fc9825aab7690000000000000000000100000000000000000000009f10600ce4d93926aad697085d601389ad8c37fb77455632ca8959c8c9277e2100000000ce0000000c0000006d00000061000000100000001800000061000000009d966b01000000490000001000000030000000310000009bd7e06f3ecf4be0f2fcd2188b23f1b9fcc88e5d4b65a8637b17723bbda3cce801140000002e100f13567c24437cba94106e4060222de09565610000001000000018000000610000003d20813c03000000490000001000000030000000310000009bd7e06f3ecf4be0f2fcd2188b23f1b9fcc88e5d4b65a8637b17723bbda3cce8011400000050009c1a1562b8ed64cedd2bf049cb8ee8a30328140000000c000000100000000000000000000000',
          },
          {
            name: 'witnessHex',
            type: 'textarea',
            required: true,
            label: 'Witness Hex',
            description: 'Hex-encoded witness data',
            value:
              '55000000100000005500000055000000410000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000',
          },
        ],
      },
      {
        title: 'Mock xUDT Transaction',
        parameters: [
          {
            name: 'path',
            type: 'string',
            required: true,
            label: 'Derivation Path',
            description: 'BIP32 derivation path',
            value: "m/44'/309'/0'/0/0",
          },
          {
            name: 'network',
            type: 'string',
            required: true,
            label: 'Network',
            description: 'Nervos network name',
            value: 'ckb',
          },
          {
            name: 'rawTx',
            type: 'textarea',
            required: true,
            label: 'Raw Transaction',
            description: 'Hex-encoded raw transaction data',
            value:
              'b00100001c000000200000006e00000072000000ce0000009c0100000000000002000000c07844ce21b38e4b071dd0e1ee3b0e27afd8d7532491327f39b786343f558ab70000000000f05188e5f3a6767fc4687faf45ba5f1a6e25d3ada6129dae8722cb282f262493000000000100000000020000000000000000000000319b793de06fcdfb727659811981f2d635c9b55693a3fb85e8de2b158575422300000000000000000000000031013016b6b0b1e84d715fb798ee79d39111b15b41920e5a4aa5c0bac47254db00000000ce0000000c0000006d000000610000001000000018000000610000000002648901000000490000001000000030000000310000009bd7e06f3ecf4be0f2fcd2188b23f1b9fcc88e5d4b65a8637b17723bbda3cce801140000006655cba91b01e4f8e3ecb40d1fb6241a9033115a610000001000000018000000610000009651104802000000490000001000000030000000310000009bd7e06f3ecf4be0f2fcd2188b23f1b9fcc88e5d4b65a8637b17723bbda3cce80114000000fb36a5944e2626089db2f37e9a5cb4a6eff55c82140000000c000000100000000000000000000000',
          },
          {
            name: 'witnessHex',
            type: 'textarea',
            required: true,
            label: 'Witness Hex',
            description: 'Hex-encoded witness data',
            value:
              '55000000100000005500000055000000410000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000',
          },
        ],
      },
    ],
  },
];

// 导出链配置对象
export const nervos: {
  api: UnifiedMethodConfig[];
  id: ChainCategory;
} = {
  id: 'nervos',
  api,
};
